import React, {Component} from 'react';
import {Breadcrumb, Button, Form, Grid, Header, Segment, Select, Table} from 'semantic-ui-react';
import {Helmet} from "react-helmet";
import {Link} from "react-router-dom";
import CustomDivider from "../../components/extras/CustomDivider";
import InvoiceData from "../../data/InvoiceData";
import Loading from "../../components/extras/Loading";
import update from "react-addons-update";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import * as moment from "moment";
import BranchOfficeData from "../../data/BranchOfficeData";

class Invoice extends Component {
    constructor(){
        super();
        this.state = {
            data:{
                billing_number:'',
                title: '',
                header: '',
                prefix: '',
                footer: '',
                legal: '',
                show_logo: false
            },
            branch_offices: [],
            branch_office: {
                id: '',
                name: ''
            },
            loading: true,
            sending: false,
            date: new Date()
        };
    }
    componentWillMount() {
        this.initialFetch();
    }

    async initialFetch() {
        await this.getBranchOffices();
    }

    async getBranchOffices() {
        await BranchOfficeData.listAll().then(async branch_offices =>{
            this.setState({branch_offices});
            await this.handleBranchOfficeChange(branch_offices[0].key)
        });
    };

    handleBranchOfficeChange = async (result) => {
        const data = await InvoiceData.get_branch_office(result);
        this.setState({branch_office: {id: result, name: result}});
        this.setState({data, loading:false});
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({sending: true});
        let data = this.state.data
        data['id'] = this.state.branch_office.id
        InvoiceData.update(this.state.data, (res) => {
            if (res.update) {
                this.props.showToast({message:'Información Actualizada!', type:'success'});
            } else {
                this.props.showToast({message:'Tenemos un problema, inténtalo más tarde!', type:'error'});
            }
            this.setState({sending: false});
        });
    };

    handleBillingNumberChange = (event) => {
        let billing_number = update(this.state, {
            data: {
                billing_number: {$set: event.target.value},
            }
        });
        this.setState(billing_number);
    };

    handlePrefixChange = (event) => {
        let prefix = update(this.state, {
            data: {
                prefix: {$set: event.target.value},
            }
        });
        this.setState(prefix);
    };

    handleBillingStoreNameChange = (event) =>{
        let store_name = update(this.state, {
            data: {
                store_name: {$set: event.target.value},
            }
        });
        this.setState(store_name);
    };

    handleBillingLegalChange = (event) =>{
        let legal = update(this.state, {
            data: {
                legal: {$set: event.target.value},
            }
        });
        this.setState(legal);
    };

    handleTitleChange = (event) =>{
        let title = update(this.state, {
            data: {
                title: {$set: event.target.value},
            }
        });
        this.setState(title);
    };

    handleHeaderChange = (event) =>{
        let header = update(this.state, {
            data: {
                header: {$set: event.target.value},
            }
        });
        this.setState(header);
    };

    handleFooterChange = (event) =>{
        let footer = update(this.state, {
            data: {
                footer: {$set: event.target.value},
            }
        });
        this.setState(footer);
    };

    handleShowLogo = () => {
        let data = this.state.data;
        let show_logo = this.state.data.show_logo;
        data.show_logo = !show_logo;
        this.setState(data);
    };
    render() {
        return (
            <div>
                <Helmet>
                    <title>Facturación | Configuraciones - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Facturación</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {this.state.loading ? <Loading/>:
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Form>
                                    <Form.Field inline>
                                        <label>Sucursal:</label>
                                        <Select options={this.state.branch_offices}
                                                onChange={(e, {value}) => this.handleBranchOfficeChange(value)}
                                                value={this.state.branch_office.id} placeholder='Sucursal'
                                                error={this.state.branch_office_error} width={4}/>
                                    </Form.Field>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column mobile={16} computer={6}>
                                <Form onSubmit={this.handleSubmit}>
                                    <Form.Input label='Nº de Factura Actual' placeholder='Nº de Factura Actual' type='number' required={true}
                                                value={this.state.data.billing_number} onChange={this.handleBillingNumberChange}
                                                error={!this.state.data.billing_number}/>
                                    <Form.Input label='Prefijo' placeholder='Prefijo'
                                                value={this.state.data.prefix} onChange={this.handlePrefixChange} />
                                    <Form.Input label='Establecimiento' placeholder='Establecimiento' type='text' required={true}
                                                value={this.state.data.store_name} onChange={this.handleBillingStoreNameChange}
                                                error={!this.state.data.store_name}/>
                                    <Form.TextArea label='Nota Legal' placeholder='Nota Legal'
                                                value={this.state.data.legal} onChange={this.handleBillingLegalChange}/>
                                    <Form.Input label='Título' placeholder='Título' type='text' error={!this.state.data.title}
                                                value={this.state.data.title} onChange={this.handleTitleChange}/>
                                    <Form.TextArea label='Cabecera' placeholder='Cabecera' required={true}
                                                value={this.state.data.header} onChange={this.handleHeaderChange}/>
                                    <Form.TextArea label='Pie de Página' placeholder='Pie de Página' required={true}
                                                   value={this.state.data.footer} onChange={this.handleFooterChange}/>
                                    <Form.Checkbox label='Mostrar Logo' checked={this.state.data.show_logo} onChange={this.handleShowLogo} />
                                    <p>
                                        <Button primary fluid disabled={this.state.sending} loading={this.state.sending}
                                                type="submit" content="Actualizar Información"/>
                                    </p>
                                </Form>
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={6} floated='right'>
                                <Segment>
                                    <Header as='h2'>
                                        <Header.Content>Vista Previa</Header.Content>
                                    </Header>
                                    <CustomDivider/>
                                    <p style={{textAlign:'center'}}>
                                        <strong>{this.state.data.store_name.toUpperCase()}</strong>
                                        <br/>
                                        <strong>NIT: 000001 - Régimen Común</strong>
                                        <br/>
                                        <p style={{textAlign:'center', whiteSpace: 'pre-line'}}>{this.state.data.legal}</p>
                                    </p>
                                    <p style={{textAlign:'center', whiteSpace: 'pre-line'}}>
                                        {this.state.data.header}
                                    </p>
                                    <p style={{textAlign:'center'}}>
                                        <strong>{this.state.data.title.toUpperCase()} - {this.state.data.prefix}{this.state.data.billing_number}</strong>
                                    </p>
                                    <p style={{textAlign:'left'}}>
                                        Fecha: {moment(this.state.date).format("MM/DD/YYYY")}
                                        <br/>
                                        Hora: {moment(this.state.date).format("hh:mm A")}
                                        <br/>
                                        Cliente: Quipuu
                                        <br/>
                                        Identificación: 1234567890
                                        <br/>
                                        Atendido por: Quipuu
                                        <hr/>
                                    </p>
                                    <p style={{textAlign:'center'}}>
                                        <strong>DETALLE DE VENTA</strong>
                                    </p>
                                    <p style={{textAlign:'left'}}>
                                        <Table style={{border:0}}>
                                            <Table.Row>
                                                <Table.Cell>
                                                    Producto 1
                                                    <br/>
                                                    2 x $2.500
                                                </Table.Cell>
                                                <Table.Cell textAlign='right'>
                                                    <br/>
                                                    $5.000
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>
                                                    Producto 2
                                                    <br/>
                                                    1 x $8.000
                                                </Table.Cell>
                                                <Table.Cell textAlign='right'>
                                                    <br/>
                                                    $8.000
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell textAlign='right' colSpan={2}>
                                                    SUB: $13.000
                                                    <br/>
                                                    DESC: $1.000
                                                    <br/>
                                                    ABONOS: $2.000
                                                    <br/>
                                                    <strong>TOTAL: $10.000</strong>
                                                </Table.Cell>
                                            </Table.Row>
                                        </Table>
                                    </p>
                                    <p style={{textAlign:'center'}}>
                                        <strong>INFORMACIÓN TRIBUTARIA</strong>
                                        <Table style={{border:0}}>
                                            <Table.Row>
                                                <Table.Cell textAlign='center'>
                                                    %
                                                    <br/>
                                                    0%
                                                </Table.Cell>
                                                <Table.Cell textAlign='center'>
                                                    Valor Base
                                                    <br/>
                                                    $0.0
                                                </Table.Cell>
                                                <Table.Cell textAlign='center'>
                                                    Valor Impuesto
                                                    <br/>
                                                    $0.0
                                                </Table.Cell>
                                            </Table.Row>
                                        </Table>
                                    </p>
                                    <p style={{textAlign:'center', whiteSpace: 'pre-line'}}>
                                        {this.state.data.footer}
                                        <br/>
                                        <br/>
                                        <small>Impreso por quipuu.com</small>
                                    </p>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showToast(toast){
            dispatch(showToast(toast))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(Invoice)



// WEBPACK FOOTER //
// ./src/containers/settings/Invoice.js